import React from 'react';
import user from '../icons/user.svg';
import search from '../icons/search.svg';
import shopbag from '../icons/shopbag.svg';

const Header = () => {
	return (
		<div className='wrapper'>
			<div className='header'>
				<span className='store_name'>Bookshop</span>
				<span className='herotext'>
					We have best collections !!
				</span>
				<div className='icons'>
					<img className='user' src={user} alt='user' />
					<img className='search' src={search} alt='search' />
					<img src={shopbag} alt='shopbag' />
				</div>
			</div>
		</div>
	);
};

export default Header;
